import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconList({
    color = '#000000',
    title = 'list',
    className,
    ariaHidden = true,
}: IconProps): ReactElement {
    return (
        <svg
            width='20px'
            height='22px'
            viewBox='0 0 20 22'
            className={className}
            xmlns='http://www.w3.org/1999/xlink'
            aria-hidden={ariaHidden}
        >
            <title>{title}</title>
            <g
                id='J2---Admin-Roles'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
                strokeLinejoin='round'
            >
                <g
                    id='Eligibility-worklist-nav-option---Desktop'
                    transform='translate(-167.000000, -953.000000)'
                    stroke={color}
                    strokeWidth='2'
                >
                    <g id='Group' transform='translate(165.000000, 952.000000)'>
                        <g id='Group' transform='translate(3.000000, 2.000000)'>
                            <circle id='Oval' cx='2' cy='2' r='2' />
                            <line x1='8' y1='2' x2='18' y2='2' id='Line' />
                            <line x1='8' y1='10' x2='18' y2='10' id='Line-Copy' />
                            <line x1='8' y1='18' x2='18' y2='18' id='Line-Copy-2' />
                            <circle id='Oval-Copy' cx='2' cy='10' r='2' />
                            <circle id='Oval-Copy-2' cx='2' cy='18' r='2' />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
